import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: 0,
}

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1
    },
    decrement: (state) => {
      state.value -= 1
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload
    },
  },
})

// counterSlice.actions　→ reducers：をもとに生成されたアクションクリエーターが入っている
// 各アクションに対応するアクションクリエーター
export const { increment, decrement, incrementByAmount } = counterSlice.actions

// counterSlice.reducer　→ createSliceでスライスオブジェクトを生成する際の引数「reducers: 」をもとに生成されるプロパティ
// 各アクションに対応するリデューサー関数
export default counterSlice.reducer